// extracted by mini-css-extract-plugin
module.exports = {"FilterCollection":"L_ZAr"};